type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const InstagramVerifiedBadge = (props: Props) => {
  const {
    width = '14',
    height = '14',
    viewBox = '0 0 24 24',
    fillColor = '#0095F6',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <path
        d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 1 8.6 2.54 6.71 5.72l-3.61.81.34 3.69L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 20.92l3.4 1.54 1.89-3.18 3.61-.82-.34-3.68L23 12Z"
        fill={fillColor}
      />
      <path
        d="m10 16.4-4-4 1.41-1.41L10 13.57l6.59-6.59L18 8.4l-8 8Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default InstagramVerifiedBadge;
